var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgArrowForwardOutlined = function SvgArrowForwardOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 3.33334L8.82498 4.50834L13.475 9.16668H3.33331V10.8333H13.475L8.82498 15.4917L9.99998 16.6667L16.6666 10L9.99998 3.33334Z",
    fill: "currentColor"
  })));
};
var Memo = /*#__PURE__*/memo(SvgArrowForwardOutlined);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/arrow-forward-outlined.dac88e8513166bade5105698780c52a6.svg";